var map = {
	"./album.svg": 9432,
	"./array-download-tray.svg": 1788,
	"./arrow-left-end-on-rectangle.svg": 9662,
	"./cd.svg": 6018,
	"./check-circle.svg": 2670,
	"./check.svg": 2497,
	"./chevron-double-down.svg": 2427,
	"./chevron-double-up.svg": 4452,
	"./chevron-down.svg": 9573,
	"./chevron-left.svg": 2526,
	"./chevron-right.svg": 9501,
	"./clock.svg": 2075,
	"./code-bracket-square.svg": 2097,
	"./cog-8-tooth.svg": 2958,
	"./dashboard-speed.svg": 4459,
	"./document-plus.svg": 6513,
	"./fire.svg": 2047,
	"./folder-open.svg": 6692,
	"./font-size-larger.svg": 7558,
	"./font-size-smaller.svg": 5345,
	"./headphone.svg": 5671,
	"./heart-outline.svg": 320,
	"./heart.svg": 9733,
	"./hq.svg": 7866,
	"./identification.svg": 8037,
	"./language.svg": 8997,
	"./list-bullet.svg": 6672,
	"./lock-closed.svg": 8819,
	"./lock-open.svg": 1823,
	"./logo.svg": 6962,
	"./lq.svg": 2334,
	"./lyric-en.svg": 9640,
	"./lyric.svg": 4291,
	"./magnifying-glass.svg": 1291,
	"./minus.svg": 8441,
	"./motion-play.svg": 5292,
	"./musical-note.svg": 7828,
	"./pause.svg": 1947,
	"./pencil-square.svg": 7592,
	"./picture-in-picture-line.svg": 7195,
	"./play.svg": 757,
	"./playlist.svg": 7485,
	"./plus-circle.svg": 8648,
	"./plus.svg": 4491,
	"./question-mark-circle.svg": 9788,
	"./repeat-song-1.svg": 2686,
	"./repeat-song.svg": 4624,
	"./rolling-1s.svg": 7099,
	"./sd.svg": 1362,
	"./shuffle.svg": 8342,
	"./skip-left.svg": 6980,
	"./skip-right.svg": 4187,
	"./sort-asc.svg": 8051,
	"./sort-desc.svg": 1419,
	"./sort.svg": 2871,
	"./sparkles.svg": 5930,
	"./speaker-wave.svg": 6360,
	"./speaker-x-mark.svg": 4729,
	"./sq.svg": 5311,
	"./t-shirt-line.svg": 4237,
	"./trash.svg": 6891,
	"./trophy.svg": 505,
	"./user.svg": 698,
	"./x-mark.svg": 5465
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;